import { forwardRef } from 'react';

import { useParams } from 'react-router-dom';

import { DocMentionsInput, DocMentionsInputHandle } from '@/new/components/doc-mentions-input';
import { Icon } from '@/new/components/icon';
import { Button } from '@/new/components/shadcn/button';

interface KimInputProps {
  value: string;
  onChange: (value: string) => void;
  onSubmit: () => void;
  placeholder?: string;
  className?: string;
  disabled?: boolean;
  autoFocus?: boolean;
}

export const KimInput = forwardRef<DocMentionsInputHandle, KimInputProps>(function KimInput(
  { value, onChange, onSubmit, placeholder, className, disabled, autoFocus },
  ref,
) {
  const { matterId, subsetId } = useParams();

  if (!matterId || !subsetId) return null;

  return (
    <div className="relative w-full">
      <DocMentionsInput
        ref={ref}
        value={value}
        onChange={onChange}
        onSubmit={onSubmit}
        matterId={matterId}
        subsetId={subsetId}
        placeholder={placeholder}
        className={className}
        disabled={disabled}
        autoFocus={autoFocus}
      />

      <Button
        disabled={disabled}
        onClick={onSubmit}
        variant="primary"
        className="absolute right-3 bottom-3 size-8 rounded-full"
      >
        <Icon className="lucide--arrow-right" />
      </Button>
    </div>
  );
});
